import React from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";

import { BRANCH_ADMIN, INTERNAL_ADMIN, StatusList, getIcon } from "common/constants/constants";
import SearchField from "components/common/customSearchField/CustomSearchField";
import SearchableSelect from "components/common/searchableSelect/SearchableSelect";
import SortingOrder from "components/common/sortingOrder/SortingOrder";

import ClearFiltersIcon from "../../../assets/icons/ClearFiltersIcon";
import { useTranslation } from "react-i18next";
const EndUserActionBar = (props) => {
  const { t } = useTranslation();

  const {
    bankList,
    branchList,
    handleChange,
    isBranchLoading,
    rolesList,
    productList,
    searchPlaceholder,
    filters,
    orderByList,
    resetFilters,
  } = props;
  const ADMIN_ROLES_KEYS = [BRANCH_ADMIN, INTERNAL_ADMIN];
  return (
    <Container>
      <Row>
        <Col
          lg={1}
          md={2}
          xs={12}
          className="d-flex flex-md-column align-items-center  justify-content-md-center justify-content-around align-item-center flex-row">
          {filters.orderBy ? (
            <SortingOrder handleChange={handleChange} value={filters.orderType} />
          ) : (
            <div
              style={{
                pointerEvents: "none",
                opacity: 0.4,
              }}>
              <SortingOrder handleChange={handleChange} value={filters.orderType} />
            </div>
          )}
          {Object.values(filters).some((el) => el !== "DESC" && el.length > 0) && (
            <ClearFiltersIcon resetFilters={resetFilters} />
          )}
        </Col>
        <Col lg={3} md={10} xs={12}>
          <SearchableSelect
            name="orderBy"
            placeholder={t("sort-by")}
            options={orderByList.map((el) => {
              return { value: el.value, label: el.name };
            })}
            value={filters.orderBy}
            handleChange={handleChange}
          />
          <SearchableSelect
            placeholder={t("all-products")}
            name="products"
            options={productList?.map((el) => {
              return {
                value: "%23" + el.productKey.substring(1),
                label: el.translatedValue,
                icon: getIcon[el?.productKey.replaceAll("#", "").toLowerCase()],
              };
            })}
            handleChange={(key, value) => handleChange(key, value)}
            value={filters?.products}
            isMulti={true}
            className=" eg-bar-select "
            withIcon
          />
          <SearchableSelect
            placeholder={t("status")}
            name="status"
            options={StatusList.map((status) => {
              return { value: status.value, label: t(status.label) };
            })}
            handleChange={(key, value) => handleChange(key, value)}
            value={filters?.status}
            isMulti={false}
            className=" eg-bar-select "
          />
        </Col>

        <Col lg={3} md={6} xs={12}>
          {ADMIN_ROLES_KEYS.includes(JSON.parse(localStorage.getItem("userRole"))?.roleName) && (
            <SearchableSelect
              placeholder={t("all-roles")}
              name="roles"
              options={rolesList.map((role) => {
                return { value: role.name, label: t(role.name) };
              })}
              handleChange={(key, value) => handleChange(key, value)}
              value={filters?.roles}
              isMulti={true}
              className=" eg-bar-select "
            />
          )}
          <SearchField
            name="searchString"
            placeholder={searchPlaceholder}
            value={filters.searchString}
            margin="6px"
            {...props}
          />
        </Col>
        <Col lg={3} md={6} xs={12}>
          {JSON.parse(localStorage.getItem("userRole"))?.roleName?.includes("IA") && (
            <>
              <SearchableSelect
                placeholder={t("all-banks")}
                name="bankId"
                options={bankList.map((bank) => {
                  return { value: bank.value, label: bank.name };
                })}
                handleChange={(key, value) => handleChange(key, value)}
                value={filters?.bankId}
              />
              <SearchableSelect
                placeholder={t("all-branches")}
                name="branchId"
                options={branchList.map((branch) => {
                  return { value: branch.value, label: branch.name };
                })}
                handleChange={(key, value) => handleChange(key, value)}
                isDisabled={branchList.length > 0 ? false : true}
                value={filters?.branchId}
                isLoading={isBranchLoading}
              />
            </>
          )}
        </Col>
        {/* <Col
          lg={2}
          md={12}
          xs={12}
          className="d-flex justify-content-center align-item-center"
        >
          <div className="py-2">
            {checkPermission(MANAGE_USERS) && <InviteUser />}
          </div>
        </Col> */}
      </Row>
    </Container>
  );
};

export default EndUserActionBar;
